import Routes from 'Routes';
import './app.scss';

const App = () => {
    return(
        <Routes />
    );
}

export default App;